import get from 'lodash.get';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Types
import { AppState } from 'services/types';

// Local Types
import {
    HarvestPrintPropertyType,
    HarvestPrintPropertyId,
    HarvestPrintPropertiesState,
    HarvestPrintPropertiesProps
} from './types';

const selectHarvestPrintProperties = (
    state: AppState
): HarvestPrintPropertiesState => state.harvestPrintProperties;
const selectHarvestPrintPropertyType = (
    _state: AppState,
    props: HarvestPrintPropertiesProps
): HarvestPrintPropertyType => props.harvestPrintPropertyType;
const selectHarvestPrintPropertyId = (
    _state: AppState,
    props: HarvestPrintPropertiesProps
): HarvestPrintPropertyId | undefined => props.harvestPrintPropertyId;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSelectHarvestPrintPropertiesArray = () =>
    createDeepEqualSelector(
        selectHarvestPrintProperties,
        selectHarvestPrintPropertyType,
        (harvestPrintPropertiesState, harvestPrintPropertyType) =>
            Object.values(harvestPrintPropertiesState[harvestPrintPropertyType])
    );

const selectHarvestPrintProperty = createDeepEqualSelector(
    selectHarvestPrintProperties,
    selectHarvestPrintPropertyType,
    selectHarvestPrintPropertyId,
    (
        harvestPrintPropertiesState,
        harvestPrintPropertyType,
        harvestPrintPropertyId
    ) => {
        if (!harvestPrintPropertyId) {
            return undefined;
        }
        return get(harvestPrintPropertiesState, [
            harvestPrintPropertyType,
            harvestPrintPropertyId
        ]);
    }
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSelectHarvestPrintPropertyName = () =>
    createDeepEqualSelector(
        selectHarvestPrintProperty,
        harvestPrintPropertyState => get(harvestPrintPropertyState, 'name')
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeSelectHarvestPrintPropertyExternalId = () =>
    createDeepEqualSelector(
        selectHarvestPrintProperty,
        harvestPrintPropertyState =>
            get(harvestPrintPropertyState, 'externalId')
    );

export {
    selectHarvestPrintProperties,
    selectHarvestPrintPropertyType,
    selectHarvestPrintPropertyId,
    makeSelectHarvestPrintPropertiesArray,
    selectHarvestPrintProperty,
    makeSelectHarvestPrintPropertyName,
    makeSelectHarvestPrintPropertyExternalId
};
